module.exports = __webpack_public_path__ + "img/gift-workmate-bg.62a16fb1.png";